import { connect } from "react-redux";
import EmployeeCreditPolicy from "./employeeCreditPolicy";
import { bindActionCreators } from "redux";
import {
    creditListing, teamListing
} from "services/redux/creditPolicy/action";

const mapStateToProps = (state) => ({
    creditsList: state.creditPolicyReducer.creditsList,
    teamsList: state.creditPolicyReducer.teamsList
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      creditListing,
      teamListing
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeCreditPolicy);
